import { render, staticRenderFns } from "./DrawerStatusHistoryTab.vue?vue&type=template&id=1c360381&scoped=true"
import script from "./DrawerStatusHistoryTab.vue?vue&type=script&lang=js"
export * from "./DrawerStatusHistoryTab.vue?vue&type=script&lang=js"
import style0 from "./DrawerStatusHistoryTab.vue?vue&type=style&index=0&id=1c360381&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c360381",
  null
  
)

export default component.exports